import React, { Fragment, useEffect } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { InputField } from "../../components/ReactHooksFormFields/inputField";
import { TiInfo } from "react-icons/ti";
import { MdClose } from "react-icons/md";
import URIFields from "./URIFields";

function FhirEditDialog({
  isOpen,
  onClose,
  isLoading,
  onSave,
  recordId,
  selectedRecord
}) {
  const { control, handleSubmit, formState: { errors }, setValue } = useForm({
    defaultValues: {
      records: [{ redirect_uris: "" }],
    },
  });
  const { fields, append, remove } = useFieldArray({
    control,
    name: `records`,
  });
console.log({selectedRecord});
useEffect(() => {
  if (selectedRecord?.redirect_uris?.length) {
    // Clear existing fields
    setValue("records", []);

    // Set them as array of objects
    const formatted = selectedRecord.redirect_uris.map((uri) => ({
      redirect_uris: uri,
    }));
    setValue("records", formatted);
  }
  if (selectedRecord?.client_id) {
    setValue("client_id", selectedRecord?.client_id);
  }
  if (selectedRecord?.username) {
    setValue("username", selectedRecord?.username);
  }
}, [selectedRecord, setValue]);

console.log(fields, selectedRecord?.redirect_uris, "fields");

  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl max-w-3xl w-full max-h-[90vh] overflow-hidden">
        {/* Dialog Header */}
        <div className="flex justify-between items-center p-4 border-b border-gray-300 bg-blue-50">
          <div className="flex items-center gap-2">
            <TiInfo color="blue" size={24} />
            <h3 className="text-lg font-semibold text-blue-700">Edit FHIR Configuration</h3>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-2xl p-1 hover:bg-gray-200 rounded"
            disabled={isLoading}
          >
            <MdClose />
          </button>
        </div>

        {/* Dialog Content */}
        <div className="p-6 overflow-y-auto max-h-[calc(90vh-160px)]">
          <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded">
            <p className="text-sm text-blue-700">
              <strong>Note:</strong> Client Secret and Password are same as Patient Portal credentials
            </p>
          </div>

          {/* FHIR URIs Section */}
          <div className="mb-6">
            <h4 className="text-base font-semibold text-gray-700 mb-3">FHIR URIs</h4>
            <div className="space-y-3">
              {fields.map((field, innerIndex) => (
                <Fragment key={field.id}>
                    <URIFields selectedRecord={selectedRecord} setValue={setValue} control={control} errors={errors} remove={remove} isLoading={isLoading} fields={fields} innerIndex={innerIndex} />
                </Fragment>
              ))}
            </div>

            <button
              type="button"
              onClick={(e) => {
                e.preventDefault();
                append({});
              }}
              className="mt-4 bg-green-600 text-white px-4 py-2 rounded text-sm hover:bg-green-700 transition"
              disabled={isLoading}
            >
              + Add FHIR URI
            </button>
          </div>

          {/* Client ID and Username */}
          <div className="grid grid-cols-2 gap-4">
            <InputField
              control={control}
              title="Client ID"
              name={`client_id`}
              isDisabled={true}
              placeholder="Client ID"
            />
            <InputField
              control={control}
              title="Username"
              name={`username`}
              isDisabled={true}
              placeholder="Username"
            />
          </div>
        </div>

        {/* Dialog Footer */}
        <div className="flex justify-end gap-3 p-4 border-t border-gray-300 bg-gray-50">
          <button
            type="button"
            onClick={onClose}
            className="bg-gray-500 text-white px-6 py-2 rounded text-sm hover:bg-gray-600 transition"
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={(e) => {
              e.preventDefault();
              handleSubmit(onSave)(recordId);
            }}
            className="bg-green-600 text-white px-6 py-2 rounded text-sm hover:bg-green-700 transition"
            disabled={isLoading}
          >
            {isLoading ? "Saving..." : "Save Changes"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default FhirEditDialog;


